<script>
    import { createEventDispatcher } from 'svelte';
    import { fetchData } from '../utils/Data.svelte'
    export let messageToken;
    let user = "";
    let email = false;
    let password = "";
    let otp = "";
    let loading = false;
    let error = "";
	const dispatch = createEventDispatcher();
    async function loginHandler() {
        loading = true;
        error = "";
        if (email) {
            document.getElementById("emailForm").submit();
        }
        else {
            user = user.toLowerCase();
            let [res, err]  = await fetchData("/v1/session", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-message-token': messageToken
                },
                body: JSON.stringify({
                    user: user, 
                    password: password,
                    otp: otp
                })
            });
            loading = false;
            if (err) {
                error = err;
                return;
            }
            dispatch('message', {
                type: "session",
                data: res.data
            });
            close();
        }
    }

	function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
        <div class="modal-header">
            <div class="modal-title h5">Sign In</div>
        </div>
        <div class="modal-body">
            {#if email}
                 <form id="emailForm" class="content" action="/account/login" method="POST" on:submit|preventDefault={loginHandler}>
                    <input type="hidden" name="returnUrl" value="{window.location.href}" />
                    <div class="form-group">
                    <input type="text" autocapitalize="off" class="form-input input-lg is-success username" name="email" placeholder="Email Address">
                    <p class="form-input-hint">If you don't receive an email, please try again.</p>
                    </div>
                    <input type="submit" style="position: absolute; left: -9999px"/>
                </form>
            {:else}
                <form class="content" on:submit|preventDefault={loginHandler}>
                    <label class="form-label" autocapitalize="off" for="user">User</label>
                    <input class="form-input username" bind:value={user} type="text">
                    <label class="form-label" for="password">Password</label>
                    <input class="form-input" bind:value={password} type="password" id="password">
                    <label class="form-label" for="otp">One-time Password (Optional)</label>
                    <input class="form-input" bind:value={otp} type="text" autocomplete="off" id="otp">
                    <input type="submit" style="position: absolute; left: -9999px"/>
                </form>
            {/if}
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Login with email</div>
                </div>
                <div class="tile-action">
                    <div class="form-group" style="margin:0.6rem 0 0.4rem 0;">
                        <label id="newTab" class="form-switch" style="margin:0;">
                            <input type="checkbox" bind:checked={email}> 
                            <i class="form-icon"></i>
                        </label>
                    </div>
                </div>
            </div>
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error">{error}</div>
                </div>
                <div class="tile-action">
                    {#if loading}
                        <button class="btn btn-primary loading">Submit</button>
                    {:else}
                        <button class="btn btn-primary" on:click={loginHandler}>Submit</button>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .error {
        color: red;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .modal-container .modal-header {
        padding-bottom: 0;
    }
    .modal-container .modal-body {
        padding-top: 0;
    }
    .modal-container .modal-footer {
        padding-top: 0;
    }
    .username {
        text-transform: lowercase;
    }
</style>